import { Box, BoxProps, Button, Flex, Text } from '@chakra-ui/react'

type Props = {
  index: number
  title: string
  disabled?: boolean
  editType?: 'create' | 'edit'
  saveButtonLabel?: string
}
export const FormSection: React.FC<Props & BoxProps> = ({
  index,
  title,
  disabled,
  children,
  editType = 'create',
  saveButtonLabel,
  ...props
}) => {
  return (
    <Box
      p="24px"
      bgColor="gray.50"
      border="1px solid"
      borderColor="gray.100"
      {...props}
    >
      <Flex
        align="center"
        gap="8px"
        mb="16px"
        borderBottom="1px solid"
        borderColor="gray.200"
        pb="12px"
      >
        {editType === 'create' && (
          <Text
            bgColor="primary.black"
            w="20px"
            h="20px"
            color="white"
            borderRadius="full"
            lineHeight="20px"
            fontWeight={700}
            fontSize="12px"
            textAlign="center"
            opacity={disabled ? '0.4' : '1'}
          >
            {index}
          </Text>
        )}
        <Text
          lineHeight={1}
          fontWeight={700}
          fontSize={editType === 'create' ? '17px' : '20px'}
          color="primary.black"
          opacity={disabled ? '0.4' : '1'}
        >
          {title}
        </Text>
      </Flex>
      {disabled ? (
        <Box>
          <Text opacity="0.4" lineHeight={1} fontWeight={700} fontSize="20px">
            未回答
          </Text>
          <Button
            mt="18px"
            disabled
            variant="outline"
            fontSize="14px"
            fontWeight={500}
            color="gray.600"
            bgColor="gray.200"
          >
            {saveButtonLabel || '保存'}
          </Button>
        </Box>
      ) : (
        children
      )}
    </Box>
  )
}
